import { render, staticRenderFns } from "./areaStatistics2023.vue?vue&type=template&id=3a0dc1cb&scoped=true&"
import script from "./areaStatistics2023.vue?vue&type=script&lang=js&"
export * from "./areaStatistics2023.vue?vue&type=script&lang=js&"
import style0 from "./areaStatistics2023.vue?vue&type=style&index=0&id=3a0dc1cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0dc1cb",
  null
  
)

export default component.exports